import { render, staticRenderFns } from "./AcryProRegistMailAddress.vue?vue&type=template&id=b7fe48b8&scoped=true"
import script from "./AcryProRegistMailAddress.vue?vue&type=script&lang=js"
export * from "./AcryProRegistMailAddress.vue?vue&type=script&lang=js"
import style0 from "./AcryProRegistMailAddress.vue?vue&type=style&index=0&id=b7fe48b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fe48b8",
  null
  
)

export default component.exports